import { SbBlokData, StoryblokImage } from '@cinch-nx/data-storyblok'
import { FinanceOffersCarousel } from '@cinch-nx/ui-finance'
import { atomStoryblokComponents } from '../../data-maps/atom-storyblok-components-map'
import { StoryblokRenderer } from '@cinch-nx/storyblok-utils'

export interface FinanceOffersCarouselBlockProps {
  title: string
  description: string
  disclaimer: string
  cards: SbBlokData[]
  placeHolderImage: StoryblokImage
}

export function FinanceOffersCarouselBlock({
  title,
  description,
  disclaimer,
  cards,
  placeHolderImage,
}: FinanceOffersCarouselBlockProps) {
  const offerCards = cards.map((card) => (
    <StoryblokRenderer block={card} components={atomStoryblokComponents} />
  ))

  return (
    <FinanceOffersCarousel
      title={title}
      description={description}
      disclaimer={disclaimer}
      cards={offerCards}
      placeHolderImage={{
        src: placeHolderImage.filename,
        alt: placeHolderImage.alt ?? '',
      }}
    />
  )
}
